import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

export const queryUserAssginedBranch = {
  async userAssignedBranch(parent, args, context, info) {
    const { lang, cdn } = args
    const { user } = context

    if (!user || !user.employeeNumber) throw new Error("User not logged in for this action")

    const config = AppSettings.sanityConfigByLang(lang)
    const client = context.sanityClient
    client.config({ ...config, useCdn: cdn })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    const employeeBranch = await client.fetch(
      groq`*[_type=="employee" && key==$key ${draftsFilter}][0] {
            "office": branchOffice->{id, title}
          }`,
      { key: user?.employeeNumber },
    )

    if (!employeeBranch || !employeeBranch?.office) return null

    return employeeBranch.office
  },
}
